import { getMeasurementTolerance } from "./measurementQuestionDetect";

const normalizeText = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

function parseAngleDegrees(value) {
  const v = normalizeText(value).replace(/degrees?/g, "").replace(/°/g, "").trim();
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
}

function parseLengthCm(value) {
  const v = normalizeText(value);
  // A comma-decimal ("3,0") is a malformed number, not "3.0" — reject it rather than stripping the
  // comma (which would read "3,0" as "30"). The dot form and bare integers still parse below.
  if (/\d,\d/.test(v)) return null;
  const m = v.match(/^(-?\d+(?:\.\d+)?)\s*(cm|mm|m)?$/);
  if (!m) {
    const n = parseFloat(v.replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : null;
  }
  let num = parseFloat(m[1]);
  const unit = m[2] || "cm";
  if (unit === "mm") num /= 10;
  if (unit === "m") num *= 100;
  return num;
}

function splitAlternatives(correct) {
  const text = String(correct ?? "");
  if (text.includes(" (or) ")) return text.split(" (or) ").map((p) => p.trim()).filter(Boolean);
  if (/ or /i.test(text)) return text.split(/ or /i).map((p) => p.trim()).filter(Boolean);
  if (text.includes(" / ")) return text.split(" / ").map((p) => p.trim()).filter(Boolean);
  return [text];
}

export function isMeasurementVerifyCorrect(submitted, correct, question, mode) {
  const tol = getMeasurementTolerance(question);

  if (mode === "angle") {
    const subDeg = parseAngleDegrees(submitted);
    if (subDeg === null) return false;
    return splitAlternatives(correct).some((alt) => {
      const corDeg = parseAngleDegrees(alt);
      if (corDeg === null) return normalizeText(submitted) === normalizeText(alt);
      let diff = Math.abs(subDeg - corDeg);
      if (diff > 180) diff = 360 - diff;
      return diff <= tol.angle;
    });
  }

  if (mode === "length") {
    const subCm = parseLengthCm(submitted);
    if (subCm === null) return false;
    return splitAlternatives(correct).some((alt) => {
      const corCm = parseLengthCm(alt);
      if (corCm === null) return normalizeText(submitted) === normalizeText(alt);
      const absTol = Math.max(tol.length_cm, Math.abs(corCm) * tol.length_pct);
      return Math.abs(subCm - corCm) <= absTol;
    });
  }

  return null;
}
